:root {
  --tap-target: 96px;
  --toolbar-width: 176px;
  --retro-bg: #c0c0c0;
  --retro-shadow-light: #ffffff;
  --retro-shadow-dark: #404040;
}

*, *::before, *::after {
  box-sizing: border-box;
}

html, body, #root {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
  overflow: hidden;
  background: var(--retro-bg);
}

body {
  font-family: Quicksand, "Varela Round", system-ui, sans-serif;
  font-weight: 500;
  color: #000;
  overscroll-behavior: none;
  touch-action: manipulation;
  -webkit-user-select: none;
  user-select: none;
}

button {
  font-family: inherit;
}

#root {
  display: flex;
  flex-direction: column;
}
